import styled from 'styled-components/macro';
import { LG } from '@zendeskgarden/react-typography';
import Flex from 'styled-flex-component';
import { variables } from 'theme/variables';
import PublicPage from 'components/PublicPages/PublicPage';

const {
  section_padding_sm,
  custom_light_grey,
  media_md,
  spacing,
  custom_blue,
  public_app_max_width
} = variables;


export const ProductsPage = styled(PublicPage)``;


export const ProductsSection = styled('div')`
  background: ${props => props.blue ? custom_blue : props.grey ? custom_light_grey : `#fff`};
  padding: 0 5px;
  @media ${media_md} {
    padding: 0 ${spacing};
  }
`;

export const Columns = styled.div`
  position: relative;
  column-count: 1;
  column-gap: 80px;
  @media ${media_md} {
    column-count: 2;
  }
`

export const ProductsSectionInner = styled('div')`
  max-width: ${public_app_max_width};
  margin: 0 auto;
  position: relative;
  padding: ${props => props.first ? `${spacing} ${spacing} ${section_padding_sm}` : section_padding_sm} 12px;
  @media ${media_md} {
    padding: ${section_padding_sm} 12px;
  }
`;

export const ProductsSectionHeader = styled(LG)`
  font-size: 26px;
  margin-bottom: ${spacing};
`;

export const Attribute = styled('div')`
  margin-bottom: ${spacing};
  display: block;
`;


export const PipefactsWrapper = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  img {
    margin-bottom: 20px;
  }
  .divider {
    display: none;
  }
  @media ${media_md} {
    align-items: center;
    flex-direction: row;    
    .divider {
      display: block;
    }
    img {
      margin-bottom: 0px;
    }
  }
`;

